import BaseApi from './baseApi';
import ICompanySettings from '../models/ICompanySettings';
import IAuthentication from '../models/IAuthentication';
export default class CompanySettingsApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "CompanySettings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetCompanySettings() : Promise<ICompanySettings[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var companySettings: ICompanySettings[] = [];
            companySettings = response.data as ICompanySettings[];
            return companySettings;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetCompanySettingsByCompanyId(companyId: string) : Promise<ICompanySettings[]> {
        const json = this.getJsonReadByCompanyId(companyId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var companySettings: ICompanySettings[] = [];
            companySettings = response.data as ICompanySettings[];
            return companySettings;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveCompanySettings(companySettings: ICompanySettings) : Promise<string> {
        const json = this.getJsonSave(companySettings);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateCompanySettings(companySettings: ICompanySettings) : Promise<boolean> {
        const json = this.getJsonUpdate(companySettings);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteCompanySettings(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "SettingsCompany",
                "Item2": "id"
            }, {
                "Item1": "SettingsCompany",
                "Item2": "idCompany"
            }, {
                "Item1": "Companies",
                "Item2": "name as companyName"
            }, {
                "Item1": "SettingsCompany",
                "Item2": "keySetting"
            }, {
                "Item1": "SettingsCompany",
                "Item2": "description"
            }, {
                "Item1": "SettingsCompany",
                "Item2": "value"
            }],
            "tables": [{
                "Item1": "SettingsCompany"
            }, {
                "Item1": "Companies"
            }],
            "joins": [{
                "Item1": "SettingsCompany",
                "Item2": "IdCompany",
                "Item3": "Companies",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "SettingsCompany",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }]
        };
        return json;
    }

    private getJsonReadByCompanyId(companyId: string) : any {
        const json = {
            "fields": [{
                "Item1": "SettingsCompany",
                "Item2": "id"
            }, {
                "Item1": "SettingsCompany",
                "Item2": "idCompany"
            }, {
                "Item1": "Companies",
                "Item2": "name as companyName"
            }, {
                "Item1": "SettingsCompany",
                "Item2": "keySetting"
            }, {
                "Item1": "SettingsCompany",
                "Item2": "description"
            }, {
                "Item1": "SettingsCompany",
                "Item2": "value"
            }],
            "tables": [{
                "Item1": "SettingsCompany"
            }, {
                "Item1": "Companies"
            }],
            "joins": [{
                "Item1": "SettingsCompany",
                "Item2": "IdCompany",
                "Item3": "Companies",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "SettingsCompany",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "SettingsCompany",
                "Item2": "IdCompany",
                "Item3": "=",
                "Item4": companyId
            }]
        };
        return json;
    }
    
    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "SettingsCompany",
            "conditions": [{
                "Item1": "SettingsCompany",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(companySettings: ICompanySettings) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "keySetting",
                "Item2": companySettings.keySetting
            }, {
                "Item1": "idCompany",
                "Item2": companySettings.idCompany
            }, {
                "Item1": "description",
                "Item2": companySettings.description
            }, {
                "Item1": "value",
                "Item2": companySettings.value
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "SettingsCompany"
        };
        return json;
    }

    private getJsonUpdate(companySettings: ICompanySettings) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "keySetting",
                "Item2": companySettings.keySetting
            }, {
                "Item1": "idCompany",
                "Item2": companySettings.idCompany
            }, {
                "Item1": "description",
                "Item2": companySettings.description
            }, {
                "Item1": "value",
                "Item2": companySettings.value
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "SettingsCompany",
            "keyvalue": companySettings.id
        };
        return json;
    }
}
